// Layer: Page (UI) – chỉ render JSX, gọi hook domain từ features.
import React from 'react';
import { Row, Col, Alert } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useOTPVerification } from '@/features/auth/useOTPVerification';
import { OTPInput } from '@/components/common/OTPInput';
import sdtcLogo from '@/assets/sdtc.svg';
import loginIllustration from '@/assets/login.svg';
import styles from './OTPVerificationPage.module.css';

export const OTPVerificationPage: React.FC = () => {
  const {
    otp,
    setOtp,
    loading,
    error,
    countdown,
    handleSubmit,
    handleResendOTP,
    handleGoBack,
    handleGoToLogin,
    formatTime,
  } = useOTPVerification();

  return (
    <Row className={styles.container}>
      <Col xs={0} md={14} className={styles.leftColumn}>
        <div className={styles.textContainer}>
          <h1 className={styles.mainTitle}>
            Hệ thống Quản lý Nhân sự Toàn diện
          </h1>
          <p className={styles.subtitle}>
            Nâng cao hiệu quả làm việc, tối ưu quy trình và kết nối con người trong tổ chức của bạn.
          </p>
        </div>
        <div className={styles.imageContainer}>
          <img src={loginIllustration} alt="Login Illustration" className={styles.illustration} />
        </div>
      </Col>

      <Col xs={24} md={10} className={styles.rightColumn}>
        <button
          type="button"
          onClick={handleGoBack}
          className={styles.backButton}
        >
          <ArrowLeftOutlined /> Quay lại
        </button>

        <div className={styles.formContainer}>
          <div className={styles.logoContainer}>
            <img src={sdtcLogo} alt="SDTC Logo" />
          </div>
          <h2 className={styles.formTitle}>
            Xác thực OTP
          </h2>

          <p className={styles.description}>
            Vui lòng nhập mã xác minh đã được gửi đến email của bạn
          </p>

          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              closable
              style={{ marginBottom: 16 }}
            />
          )}

          <div className={styles.otpContainer}>
            <OTPInput value={otp} onChange={setOtp} length={6} />
          </div>

          <div className={styles.resendContainer}>
            {countdown > 0 ? (
              <span className={styles.countdownText}>Gửi lại: {formatTime(countdown)}</span>
            ) : (
              <button
                type="button"
                onClick={handleResendOTP}
                disabled={loading}
                className={styles.resendButton}
              >
                Gửi lại
              </button>
            )}
          </div>

          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading}
            className={styles.submitButton}
          >
            {loading ? 'Đang xác nhận...' : 'Xác nhận'}
          </button>

          <div className={styles.backToLoginContainer}>
            <button
              type="button"
              onClick={handleGoToLogin}
              className={styles.backToLoginButton}
            >
              Trở về Đăng nhập
            </button>
          </div>
        </div>
      </Col>
    </Row>
  );
};

